"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _BookmarkedPostsHeader = _interopRequireDefault(require("./BookmarkedPostsHeader"));

var _BookmarkedPostsList = _interopRequireDefault(require("./BookmarkedPostsList"));

var _AvailableLibrarySelector = _interopRequireDefault(require("../../AvailableLibrarySelector"));

require("../styles/_bookmarked-posts.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var FeaturePostsComponent = function FeaturePostsComponent(props) {
  var getInspirationsHeader = props.getInspirationsHeader,
      getInspirations = props.getInspirations,
      history = props.history,
      fetchAssets = props.fetchAssets,
      organisationMemberships = props.organisationMemberships,
      setSelectedOrgId = props.setSelectedOrgId,
      selectedInspirationOrgId = props.selectedInspirationOrgId,
      isFeatured = props.isFeatured,
      toggleInspirationFavourite = props.toggleInspirationFavourite,
      getInspirationFavourites = props.getInspirationFavourites;
  return _react.default.createElement("div", {
    className: "bookmarked-posts page"
  }, _react.default.createElement(_BookmarkedPostsHeader.default, {
    getInspirationsHeader: getInspirationsHeader,
    selectedInspirationOrgId: selectedInspirationOrgId,
    isFeatured: isFeatured,
    history: history
  }), _react.default.createElement(_AvailableLibrarySelector.default, {
    organisationMemberships: organisationMemberships,
    setSelectedOrgId: setSelectedOrgId,
    selectedInspirationOrgId: selectedInspirationOrgId
  }), _react.default.createElement("div", {
    className: "bookmarked-posts__body"
  }, _react.default.createElement(_BookmarkedPostsList.default, {
    history: history,
    getInspirations: getInspirations,
    selectedInspirationOrgId: selectedInspirationOrgId,
    fetchAssets: fetchAssets,
    isFeatured: isFeatured,
    toggleInspirationFavourite: toggleInspirationFavourite,
    getInspirationFavourites: getInspirationFavourites
  })));
};

var _default = (0, _react.memo)(FeaturePostsComponent);

exports.default = _default;